// src/App.js

import React from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";

import Dashboard from "./Dashboard";
import PlantPage from "./pages/PlantPage";
import SignIn from "./pages/SignIn";
import SignUp from "./pages/SignUp";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import TermsOfUse from "./pages/TermsOfUse";
import UserProfilePage from "./pages/UserProfile";
import Blog from "./pages/Blog";
import SupplyChain from "./pages/SupplyChain";
import About from "./pages/About";

import Box from "@mui/material/Box";
import MainGrid from "./components/MainGrid";
import RequireAuth from "./components/RequireAuth";
import RequireRecommenderAccess from "./components/RequireRecommenderAccess";
import VerifyOTPPage from "./pages/VerifyOTP";

import Banner from "./components/Banner";
import BlogPostCreate from "./pages/BlogPostCreate";
import BlogPostDetail from "./pages/BlogPostDetail";
import PublicProfile from "./pages/PublicProfile";

// Αυτό είναι το περιεχόμενο της αρχικής σελίδας ( / ) testtt
const Home = () => (
  <Box sx={{ mx: { xs: 1, sm: 3 }, pb: 5 }}>
    <Banner
      title="Welcome to SEEDS!"
      subtitle="A unified platform for smart agriculture, data monitoring, and field insights."
      imageUrl="/images/bannerImage.jpg"
    />
    <MainGrid />
  </Box>
);

function App() {
  return (
    <Router>
      <Routes>
        {/* Public routes */}
        <Route path="/signin" element={<SignIn />} />
        <Route path="/signup" element={<SignUp />} />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="/terms-of-use" element={<TermsOfUse />} />
        <Route path="/verify-otp" element={<VerifyOTPPage />} />
        <Route
          path="/"
          element={
            <RequireAuth>
              <Dashboard />
            </RequireAuth>
          }
        >
          <Route index element={<Home />} />

          <Route
            path="plant"
            element={
              <RequireRecommenderAccess>
                <PlantPage />
              </RequireRecommenderAccess>
            }
          />
          <Route path="profile" element={<UserProfilePage />} />
          <Route path="supply" element={<SupplyChain />} />

          <Route path="blog" element={<Blog />} />
          <Route path="about" element={<About />} />
          <Route path="blog/new" element={<BlogPostCreate />} />
          <Route path="blog/:postId" element={<BlogPostDetail />} />

          {/* ✅ PublicProfile ΜΕΣΑ στο Dashboard για να κρατάς sidebar/theme */}
          <Route path="u/:username" element={<PublicProfile />} />

        </Route>
        {/* Fallback route */}
        <Route path="*" element={<Navigate to="/signin" replace />} />
      </Routes>
    </Router>
  );
}

export default App;
